import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import { upperFirst, camelCase } from "lodash";
import VueElementLoading from "vue-element-loading";
import InfiniteLoading from "vue-infinite-loading";
import VueSimpleSuggest from "vue-simple-suggest";
import VueSimpleAlert from "vue-simple-alert";
import VueTheMask from "vue-the-mask";
import Toasted from "vue-toasted";
import VueFlatPickr from "vue-flatpickr-component";
import VueCurrencyFilter from "vue-currency-filter";
import VueTippy, { TippyComponent } from "vue-tippy";
import store from "./store";

import importLocalComponents from '../../../../../../resources/assets/js/app';

require("./bootstrap");
require("./app-busca-produtos");
require('./canal-de-novidades.js');

Vue.component("VueElementLoading", VueElementLoading);
Vue.component("InfiniteLoading", InfiniteLoading);
Vue.component("VueSimpleSuggest", VueSimpleSuggest);
Vue.use(VueCurrencyFilter,
  {
    symbol: '',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  });
Vue.use(VueFlatPickr);
Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(VueTheMask);
Vue.use(Toasted, {
  iconPack: "fontawesome"
});
Vue.use(VueSimpleAlert);
Vue.use(VueTippy);

Vue.component("tippy", TippyComponent);

Vue.axios.defaults.headers.common["X-CSRF-Token"] = $(
  'meta[name="csrf-token"]'
).attr("content");

const requireComponent = require.context("./elements", true, /[\w-]+\.vue$/);

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const filenameSplit = fileName.split("/");
  const componentName = upperFirst(
    camelCase(filenameSplit[filenameSplit.length - 1].replace(/\.\w+$/, ""))
  );

  Vue.component(componentName, componentConfig.default || componentConfig);
});

importLocalComponents(require.context('./elements', true, /[\w-]+\.vue$/));

const app = new Vue({ el: "#app", store });
